import { Component, OnInit } from '@angular/core';

import * as moment from 'moment';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-fechas',
  templateUrl: './fechas.component.html',
  styleUrls: ['./fechas.component.scss'],
  providers: [CommonService]
})
export class FechasComponent implements OnInit {
  public search:any;
  public turnos:any[];
  public sobreturnos:any[];

  private dayCounter:number;
  private counter:number;

  public day;
  public weekday;
  public month;
  public year;

  constructor(private commonService:CommonService) { }

  ngOnInit() {
    this.search = {
      fecha:new Date(),
    };

    this.getTurnosYSobreturnos();
  }

  getTurnosYSobreturnos() {
    Promise.all([
      this.commonService.getTurnosXFecha(this.search),
      this.commonService.getSobreturnosXFecha(this.search),
    ]).then(result => {
      this.turnos = result[0];
      this.sobreturnos = result[1];

      this.composeFechas();
    });
  }

  searchNext():void {
    let newDate = moment(this.search.fecha).add(1, 'd');
    this.search.fecha = newDate.toDate();

    this.turnos = [];
    this.sobreturnos = [];

    this.getTurnosYSobreturnos();
  }

  searchPrev():void {
    let newDate = moment(this.search.fecha).subtract(1, 'd');
    this.search.fecha = newDate.toDate();

    this.turnos = [];
    this.sobreturnos =[];

    this.getTurnosYSobreturnos();
  }

  private composeFechas():void {
    let dias = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
      meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

    this.day = this.search.fecha.getDate();
    this.weekday = dias[this.search.fecha.getDay()];
    this.month = meses[this.search.fecha.getMonth()];
    this.year = this.search.fecha.getFullYear();
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/home/fechas/fechas.component.ts